import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-widget-error',
  imports: [MatIcon],
  templateUrl: './widget-error.component.html',
  styleUrl: './widget-error.component.scss'
})
export class WidgetErrorComponent {
  @Input({ required: true }) error: string;
  @Input({ required: true }) item: any;
}
